module.exports = __webpack_public_path__ + "static/blueair-11ddaa891bba5dcb2e14491279f368c5.svg";